import { TerceraChartMouseEventArgs } from './TerceraChartMouseEventArgs';
import { MouseButtons } from '@front/controls/UtilsClasses/ControlsUtils';
export class TerceraChartTouchEventArgs extends TerceraChartMouseEventArgs {
    constructor(window, clientLocation, pageLocation, isSingle) {
        super(window, {});
        this.isLongTap = false;
        this.wasMove = false;
        this.numericIsVisible = false;
        this.pinchYScale = false;
        this.TouchList = new Array();
        this.Button = MouseButtons.Left;
        this.isSingle = isSingle;
        this.Location = clientLocation;
        this.ClientLocation = pageLocation;
        this.X = this.Location.X;
        this.Y = this.Location.Y;
    }
}
